import { EmailDashboardComponent } from './email-dashboard.component';
export var emailDashboardroutes = [
    {
        path: 'email-dashboard',
        component: EmailDashboardComponent
    }
];
var EmailDashboardRoutingModule = (function () {
    function EmailDashboardRoutingModule() {
    }
    return EmailDashboardRoutingModule;
}());
export { EmailDashboardRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard-routing.module.ts.pre-build-optimizer.js